import Vue from 'vue';

export default {
  state: {
    downloads: null,
  },
  getters: {
    DOWNLOADS: state => {
      return state.downloads;
    },
  },
  mutations: {
    SET_DOWNLOADS: (state, payload) => {
      state.downloads = payload;
    },
  },
  actions: {
    INIT_DOWNLOADS: async (context) => {
      const loader = Vue.$loading.show();

      try {
        const downloads = await Vue.axios.get('orders/get_order_downloads');
        context.commit('SET_DOWNLOADS', downloads.data.data);

        loader.hide();
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
        loader.hide();
      }
    },
  },
};